import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    root: { position: 'relative', boxSizing: 'border-box' },
    inputNumber: {
      paddingRight: 80,
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '&': {
        MozAppearance: 'textfield',
      },
    },
    icon: {},
    container: {
      position: 'absolute',
      top: theme.spacing.sp01,
      right: theme.spacing.sp01,
    },
  },
  {
    name: 'InputNumber',
  },
);
